import axios from "config/axios/base";
import qs from "qs";

export const getSegments = ({ options = null }) => axios.get("/segments", options);
export const getSegmentCategoriesTenants = ({ params = {}, query = {}, options = null }) =>
	axios.get(`/segment-category/${params?.id}/tenants?${qs.stringify(query)}`, options);
